import React from "react";
import { Wrapper, Image } from "./styled";
import InactiveIcon from "../../../../images/gray/inactiveIcon.svg";

const InactiveIconGray = (props) => {
  return (
    <Wrapper onClick={props.onClick}>
      <Image src={InactiveIcon} alt="icon" />
    </Wrapper>
  );
};

export default InactiveIconGray;
